










import Vue from 'vue'
export default Vue.extend({
  name: "WmEmpty",
  props:{
    text:{
      type: String,
      default: ''
    }
  }
})
